import React, { useMemo } from "react";
import { FaGooglePlay, FaAppStoreIos } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import {
  ANDROID_STORE_URL,
  IOS_STORE_URL,
} from "configs/AppConfig";
import { getMobilePlatform } from "utils/detectPlatform";

/**
 * Play Store / App Store icons only (no badge text).
 * Android → Play Store | iOS → App Store | else both.
 */
const AppStoreButtons = ({
  className = "",
  size = "md",
  tooltipPlacement = "top",
}) => {
  const { t } = useTranslation();
  const platform = useMemo(() => getMobilePlatform(), []);

  const showAndroid = platform === "android" || platform === "other";
  const showIos = platform === "ios" || platform === "other";

  const iconSize = size === "sm" ? "h-5 w-5" : "h-6 w-6";
  const btnSize = size === "sm" ? "h-9 w-9" : "h-10 w-10";

  const tooltipPos =
    tooltipPlacement === "bottom"
      ? "top-full mt-2"
      : "bottom-full mb-2";

  const tooltipClass = `pointer-events-none absolute ${tooltipPos} left-1/2 z-[1100] hidden -translate-x-1/2 whitespace-nowrap rounded-md bg-maroon px-2 py-1 text-[10px] font-semibold text-white shadow-md group-hover:block`;

  return (
    <div className={`relative z-[1100] flex items-center gap-2 ${className}`}>
      {showAndroid && (
        <a
          href={ANDROID_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t("appStore.androidTitle")}
          className={`group relative grid ${btnSize} place-items-center rounded-full border border-border bg-[#01875f]/10 text-[#01875f] transition hover:border-[#01875f] hover:bg-[#01875f] hover:text-white`}
        >
          <FaGooglePlay className={iconSize} />
          <span className={tooltipClass}>{t("appStore.androidTitle")}</span>
        </a>
      )}

      {showIos && (
        <a
          href={IOS_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t("appStore.iosTitle")}
          className={`group relative grid ${btnSize} place-items-center rounded-full border border-border bg-[#0d96f6]/10 text-[#0d96f6] transition hover:border-[#0d96f6] hover:bg-[#0d96f6] hover:text-white`}
        >
          <FaAppStoreIos className={iconSize} />
          <span className={tooltipClass}>{t("appStore.iosTitle")}</span>
        </a>
      )}
    </div>
  );
};

export default AppStoreButtons;
